import { Type } from '@trustedshops/tswp-core-common';
import { PluginEntryPoint } from './plugin-entry-point.interface';

/**
 * Describes a plugin entry point
 */
export interface PluginEntryPointType extends Type<PluginEntryPoint> {
  pluginName: string;
}
